/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-15 16:27:00
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer, PageResDo } from 'src/types/base';
import { defaultNullValue } from 'src/config';
import { type } from 'os';
export declare namespace DiskConfigDOI {
    export interface RowDataI {
        brand_type: number;
        channel_total_count: number;
        create_time: string;
        dvr_url: string;
        id: number;
        name: string;
        password: string;
        status: number;
        username: string;
        device_id: number;
        device_name: string;
        type:Integer;  // 1萤石云  2乐橙云  3 本地监控
        nvr_user_id?:Integer;
        deviceserial: string;
    }

    export interface QueryRowDataParamsI extends PageDo {
        name?: string;
        type?: Integer;
        device_id?: string;
        brand_type?: string;
    }

    export interface QueryDetailResultI { }

    export interface OperateParamsI {
        id?: Integer;
        name: string;
        device_id: Integer;
        device_name: string;
        channel_total_count: Integer;
        type:Integer;  // 1萤石云  2乐橙云  3 本地监控
        username: string;
        password: string;
        dvr_url: string;
        brand_type: Integer; // 所属品牌：（0大华1海康新2海康旧）
        deviceserial: string;
        validdatecode: string;
        nvr_user_id: Integer;
        nvr_user_name: string;
    }

    export interface DeleteParamsI{
        type:Integer;
        dvr_id:Integer;
        nvr_user_id?:Integer;
        deviceserial?:Integer;
    }

    export interface GetAddress{
         channel_total_count: Integer;
         device_id: Integer;
         nvr_user_id: Integer;
         type:Integer;  // 1萤石云  2乐橙云  3 本地监控
         deviceserial: string;
         channelNo:Integer;
         ezopen_type:Integer;
         quality:Integer;
         expireTime:Integer; //过期时间
         chanels:Array;
         datatime:any;
         startTime:string;
         stopTime:string;
    }

    export interface Defence{
        nvr_user_id: Integer;
        type:Integer;  // 1萤石云  2乐橙云  3 本地监控
        deviceserial: string;
    }
}

export default class DiskConfigApi {
    /**
     * 查询列表
     * @param {DiskConfigDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(params: DiskConfigDOI.QueryRowDataParamsI): Promise<ResultPageDo<DiskConfigDOI.RowDataI[]>> {
        return Api.post('/srs_live/query/nvr/device', {
            device_id: defaultNullValue,
            nvr_type: defaultNullValue,
            name: '',
            ...params,
        });
    }


    /**
     * 根据id查询单个
     * @param {{id: number}} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchDetail(params: { id: number }): Promise<Result<DiskConfigDOI.QueryDetailResultI>> {
        return Api.post('/srs_live/query/nvr/device/by_id', params);
    }


    /**
     * 新增
     * @param {DiskConfigDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async add(data: DiskConfigDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/srs_live/add/nvr/device', data);
    }


    /**
     * 修改
     * @param {DiskConfigDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async update(data: DiskConfigDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/srs_live/edit/nvr/device', data);
    }


    /**
     * 删除
     * @param {Array<number>} data
     * @returns {Promise<Result<any>>}
     */
    static async delete(params: DiskConfigDOI.DeleteParamsI): Promise<Result<any>> {
        return Api.post('/srs_live/delete/nvr/device', { ...params });
    }
    
    /**
     * 
     * @param params 获取直播地址
     */
    static async getAddress(params: DiskConfigDOI.GetAddress): Promise<Result<any>>{
        return Api.post('/srs_live/live/address/get', { ...params });
    }
    

    static async push(params: { dvr_id: number; channel_nums: number[]; stream_type: number }): Promise<Result<any>> {
        return Api.post('/srs_live/stream/push', params);
    }

    static async close(params: { dvr_id: number; channel_nums: number[] }): Promise<Result<any>> {
        return Api.post('/srs_live/stream/close', params);
    }

    static async pushBack(params: {
        dvr_id: number;
        channel_nums: number[];
        stream_type: number;
        start_time: number;
        end_time: number;
    }): Promise<Result<any>> {
        return Api.post('/srs_live/stream/playback', params);
    }
    static async searchChanel(params: { dvr_id: number }): Promise<Result<{ dvr_id: number; channel_num: number; status: number }[]>> {
        return Api.post('/srs_live/dvr/channels/data', params);
    }

    static async searchLive(params: { dvr_id: number, device_id: number, type: 0 | 1,nvr_id: number}): Promise<ResultPageDo<{ live_url: string, channel_num: string, channel_total:string }[], any>> {
        return Api.post('/srs_live/live/data', {
            dvr_id: defaultNullValue,
            page_index: 1,
            page_size: 10000000,
            ...params,
        });
    }

    /**
     * 根据站点id查询硬盘机
     * @param params 
     */
    static async deviceIdByNvr(params: any): Promise<ResultPageDo<{ live_url: string, channel_num: string, type: number, id:number}[], any>> {
        return Api.post('/srs_live/device_id/by/nvr', params);
    }

    /**
     * 
     * @param params 开启布防
     */
     static async getDefence(params: DiskConfigDOI.Defence): Promise<Result<any>>{
        return Api.post('/srs_live/defence/set', { ...params });
    }
}
